import { useEffect } from 'react';
import SkuStore from '@/stores/sku';
import ExpressStore from '@/stores/express';
/**
 * 样品sku数据前置处理
 * @returns
 */
interface PropType {
  sampleInfo: SampleTypes.Root;
  skuInfoMap: InventoryTypes.SkuInfoMap;
  skuAttrs: SkuTypes.SkuAttr[];
  skuInventoryMap: InventoryTypes.SkuInfoMap;
  type: SkuTypes.TypeInfo;
}
export default function Sample(props: PropType) {
  const { sampleInfo, skuInfoMap, skuInventoryMap, skuAttrs, type } = props;
  if (type !== 'sample') return null;

  const skuStore = SkuStore((state) => state);
  const expressStore = ExpressStore((state) => state);
  const { dispatchId } = expressStore;

  // 拷贝主商品sku，整合库存信息
  useEffect(() => {
    if (!dispatchId) return;
    const { skuList, maxQuantity } = sampleInfo;
    // 更新样品sku
    const skuSampleMap: {
      [k: string]: SampleTypes.SkuList;
    } = {};
    skuList?.forEach((i) => {
      skuSampleMap[i.id] = {
        ...i,
      };
    });

    // 拷贝主商品sku
    const sampleSkuInfoMap: InventoryTypes.SkuInfoMap = {};
    Object.keys(skuInfoMap).forEach((key) => {
      if (skuSampleMap[skuInfoMap[key]?.id]) {
        sampleSkuInfoMap[key] = skuSampleMap[skuInfoMap[key].id];
        sampleSkuInfoMap[key].maxQuantity = maxQuantity;
      }
    });

    skuStore.setSkuInfo(
      type,
      skuAttrs.map((sku) => ({
        ...sku,
        // 样品过滤非库存,并设置选中
        values: sku.values
          .filter((i) =>
            Object.keys(sampleSkuInfoMap).some((value) => value.indexOf(`${sku.id}:${i.id}`) > -1),
          )
          .map((i, index) => ({
            ...i,
            selected: index === 0,
          })),
      })),
      skuInventoryMap,
      sampleSkuInfoMap,
      dispatchId,
    );

    skuStore.setSkuSelect(type);
  }, [dispatchId]);

  return null;
}
